import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import ResumeBox from '@/common/components/ResumeBox'
import { ModalDeleteEstablishmentInfrastructure } from '@/features/maintenance/establishmentInfrastructures/components/modalDeleteEstablishmentInfrastructure'
import { useEstablishmentInfrastructure } from '@/features/maintenance/establishmentInfrastructures/hooks/useEstablishmentInfrastructure'
import { ChevronsRightIcon } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: establishmentInfrastructure,
    isPending: establishmentInfrastructureIsPending,
    error: establishmentInfrastructureError = {} as any,
    refetch: refetchPermission,
  } = useEstablishmentInfrastructure(id || '')

  const disableUpdateButton = establishmentInfrastructureIsPending || establishmentInfrastructureError?.status === 403

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/establishment-infrastructures" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">Infraestrutura da Rede Credenciada</p>

          <ChevronsRightIcon className="text-white-400" />

          <h2>{establishmentInfrastructure?.display_name}</h2>
        </div>

        <div className="flex gap-4">
          <ModalDeleteEstablishmentInfrastructure />

          <Link
            to={disableUpdateButton ? '' : `/establishment-infrastructures/${id}/edit`}
            className={disableUpdateButton ? 'cursor-default' : ''}
          >
            <Button
              name="update_establishment_infrastructure"
              operationKlassToCheckPermission="Admin::Maintenance::EstablishmentInfrastructures::Update"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {establishmentInfrastructureIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={establishmentInfrastructureError?.status}
          refetchFunction={refetchPermission}
        >
          <Box className="max-h-[calc(100vh-128px)] flex flex-col gap-4 overflow-y-auto">
            <p className="text-lg font-bold">Infraestrutura da Rede Credenciada</p>

            <ResumeBox
              boxClassName="bg-white-200"
              label="Nome da infraestrutura"
              value={establishmentInfrastructure?.display_name || '--'}
              testId="display_name"
            />
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
